import { render, staticRenderFns } from "./DiffusionEmailsModal.vue?vue&type=template&id=7a0d4980&scoped=true&"
import script from "./DiffusionEmailsModal.vue?vue&type=script&lang=js&"
export * from "./DiffusionEmailsModal.vue?vue&type=script&lang=js&"
import style0 from "./DiffusionEmailsModal.vue?vue&type=style&index=0&id=7a0d4980&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0d4980",
  null
  
)

export default component.exports